import React from "react";
import { Skeleton } from "antd";

import { BusinessCardContainer, BusinessCardImageSkeleton } from "./BusinessCard.styles";

const BusinessCardSkeleton: React.FC = () => {
  return (
    <BusinessCardContainer hoverable cover={<BusinessCardImageSkeleton active />}>
      <Skeleton paragraph={false} />
      <Skeleton paragraph={false} />
    </BusinessCardContainer>
  );
};

export default BusinessCardSkeleton;
